import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { PaymentRequestServiceType, UserApi } from 'mvppoker-portal-common/api'
import React, { useState } from 'react'
import { toast } from 'react-hot-toast'
import { createMVPModal } from '../Modal'
import { getApi, handleError } from '../../../utils/useApi'
import { WalletAddFundsWithProviderModalView } from './WalletAddFundsWithProviderModalView'

class WalletAddFundsWithProviderModal
{
	Show(service: PaymentRequestServiceType) 
	{
		NiceModal.show(createMVPModal('wallet-add-funds-with-provider-modal', () =>
		{
			const modal = useModal()
			const [isLoading, setLoading] = useState(false)

			const clickSubmit = (amount: string) => {
				setLoading(true)
				getApi(UserApi)
					.paymentsRequestDeposit({ amount, serviceName: service })
					.then((res) => {
						setLoading(false)
						const url = res.data.invoiceUrl
						if (url) {
							// window.open(url, '_blank') //this gets blocked by pop-up blockers
							window.location.href = url
						} else {
							toast.error('We\'ve encountered an error. Please try again later.')
						}
						modal.hide()
					})
					.catch((err) => {
						setLoading(false)
						handleError(err)
					})
			}

			return <WalletAddFundsWithProviderModalView 
				service={service}			
				isLoading={isLoading}

				clickSubmit={clickSubmit}
			/>
		}))
	}
}

const modal = new WalletAddFundsWithProviderModal()
export default modal